import AreaInput from "../../../../components/AreaInput";
import CurrencyInput from "../../../../components/Currency";
import {
  DESCRIPTION_INPUT_CLASS,
  FieldLabel,
  FormSection,
} from "../../../../components/propertyDescription/descriptionUi";
import { useEditPropertyWizard } from "../EditPropertyWizardContext";

export default function ValuesSection() {
  const {
    formErrors,
    rentValue,
    setRentValue,
    condominiumValue,
    setCondominiumValue,
    iptuValue,
    setIptuValue,
    garbageTax,
    setGarbageTax,
    area,
    setArea,
  } = useEditPropertyWizard();

  return (
    <FormSection title="Valores">
      <div className="grid grid-cols-2 gap-x-4 gap-y-4 xl:grid-cols-4">
        <div className="min-w-0">
          <FieldLabel error={formErrors.rent_value}>Aluguel</FieldLabel>
          <CurrencyInput
            className={DESCRIPTION_INPUT_CLASS}
            value={Number(rentValue)}
            onValueChange={(e: number) => setRentValue(String(e))}
          />
        </div>
        <div className="min-w-0">
          <FieldLabel error={formErrors.condominium_value}>Condomínio</FieldLabel>
          <CurrencyInput
            className={DESCRIPTION_INPUT_CLASS}
            value={Number(condominiumValue)}
            onValueChange={(e: number) => setCondominiumValue(String(e))}
          />
        </div>
        <div className="min-w-0">
          <FieldLabel error={formErrors.iptu_value}>IPTU</FieldLabel>
          <CurrencyInput
            className={DESCRIPTION_INPUT_CLASS}
            value={Number(iptuValue)}
            onValueChange={(e: number) => setIptuValue(String(e))}
          />
        </div>
        <div className="min-w-0">
          <FieldLabel error={formErrors.garbage_tax}>Taxa do lixo</FieldLabel>
          <CurrencyInput
            className={DESCRIPTION_INPUT_CLASS}
            value={Number(garbageTax)}
            onValueChange={(e: number) => setGarbageTax(String(e))}
          />
        </div>
      </div>
      <div className="mt-4 max-w-xs">
        <FieldLabel error={formErrors.area}>Área útil</FieldLabel>
        <AreaInput
          value={area}
          onChange={(event) => setArea(event.target.value)}
          className={DESCRIPTION_INPUT_CLASS}
        />
      </div>
    </FormSection>
  );
}
